import request from '../../shared/request'

export function getContactsList() {
  return request('/contacts/complete-list')
}

export function createContactIndividual(payload) {
  return request(`/contacts/individual`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function companyCreateContactById(payload) {
  return request(`/contacts/byid`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function editContactIndividual(payload) {
  return request(`/contacts/individual/${payload.contactId}`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteContactIndividual(payload) {
  return request(`/contacts/individual/${payload.contactId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function addEmail(payload) {
  return request(`/contacts/email`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function editEmail(payload) {
  return request(`/contacts/email/${payload.emailId}`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteEmail(payload) {
  return request(`/contacts/email/${payload.emailId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function getEmails(contactId) {
  return request(`/contacts/email/${contactId}`)
}

export function addPhone(payload) {
  return request(`/contacts/phone`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function editPhone(payload) {
  return request(`/contacts/phone/${payload.phoneId}`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deletePhone(payload) {
  return request(`/contacts/phone/${payload.phoneId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function getPhones(contactId) {
  return request(`/contacts/phone/${contactId}`)
}

// notes
export function fetchContactNote(payload) {
  return request(`/contacts/${payload.contactId}/notes`)
}

export function createContactNote(payload) {
  return request(`/contacts/${payload.contactId}/notes`, {
    method: 'POST',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function editContactNote(payload) {
  return request(`/contacts/${payload.noteId}/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deleteContactNote(payload) {
  return request(`/contacts/${payload.noteId}/notes`, {
    method: 'DELETE',
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

// jobs
export function fetchContactJobs(payload) {
  return request(`/contacts/${payload.contactId}/jobs`)
}

// leads
export function fetchContactLeads(payload) {
  return request(`/contacts/${payload.contactId}/leads`)
}

export function fetchContactGroupsByJobId(payload) {
  return request(`/job/contacts/${payload.jobId}/contact-groups`)
}

export function updateCompanyPrimaryContact(payload) {
  return request(`/contacts/${payload.contact_id}/primary`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/contact.js